// @flow

import { selectFeatureFlag } from '@gandi/authentication';
import { useTranslator } from '@gandi/translate';

import NoRenewablesRowNDS from 'src/DomainRenew/componentsNDS/NoRenewablesRow';
import { useAppSelector } from 'src/hooks';

import NoRenewablesRowLegacy from './NoRenewablesRow';

export function NoRenewablesRowSwitch(): React.MixedElement {
  const translator = useTranslator();
  const FF_TRANSFERT_NDS = useAppSelector(state =>
    selectFeatureFlag(state, {
      featureFlagName: 'FF_TRANSFERT_NDS',
    }),
  );

  return FF_TRANSFERT_NDS ? (
    <NoRenewablesRowNDS />
  ) : (
    <NoRenewablesRowLegacy translator={translator} />
  );
}
